import React, { useState, useRef, useEffect } from 'react';
import { services } from '../constants';

export const Services: React.FC = () => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="services-dropdown-wrapper" ref={wrapperRef}>
      <button
        type="button"
        className="services-trigger"
        aria-haspopup="true"
        aria-expanded={open}
        aria-label="Services menu"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span
          className="nav-dropdown-btn"
          aria-hidden
        >
          <svg
            className="nav-dropdown-chevron"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s ease' }}
          >
            <path
              d="M6.28481 7.99994C6.51857 8.00712 6.71834 8.09269 6.88344 8.2558L10.0006 11.3564L13.1383 8.2558C13.3035 8.09259 13.4997 8.01069 13.7262 8.01069C13.9534 8.01069 14.1566 8.09912 14.3356 8.27534C14.5007 8.43855 14.5836 8.63959 14.5836 8.87787C14.5836 9.11612 14.5007 9.31723 14.3356 9.48041L10.6198 13.1523C10.5234 13.2469 10.4239 13.3153 10.3209 13.3564C10.2179 13.3969 10.1109 13.4169 10.0006 13.4169C9.89035 13.4169 9.78334 13.3969 9.68032 13.3564C9.57734 13.3153 9.47787 13.2469 9.38149 13.1523L5.64516 9.45991C5.48006 9.29673 5.40477 9.09234 5.4186 8.8476C5.43247 8.60281 5.51444 8.4053 5.66567 8.2558C5.84459 8.07897 6.05113 7.99351 6.28481 7.99994Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className="header-nav-item header-nav-label">Services</span>
      </button>
      {open && (
        <div className="services-dropdown" role="menu">
          {services.map(({ title, href }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="services-dropdown-item"
              role="menuitem"
              onClick={() => setOpen(false)}
            >
              {title}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
